import { inject, Injectable } from "@angular/core";
import { BaseHttpService } from "../../services/common/base.http.service";
import { Observable } from "rxjs";
import { HttpHeaders } from "@angular/common/http";
import { administrationConst } from "../administration.const";
import { PayGradeBenefitsModel } from "../models/pay-grade-benefits.model";
import { CodeModel } from "../models/code.model";
import { ResultInfo } from "../../shared/models/result-info.model";

@Injectable({
  providedIn: 'root'
})
export class PayGradeBenefitsService {
  baseHttpService = inject(BaseHttpService);

  getPayGradeBenefit(): Observable<PayGradeBenefitsModel[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });    
    return this.baseHttpService.get<PayGradeBenefitsModel[]>(administrationConst.payGradeBenefits, { headers: headers });
  }

  updatePayGradeBenefit(data: PayGradeBenefitsModel[]): Observable<ResultInfo> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.put<ResultInfo>(administrationConst.payGradeBenefits, data, { headers: headers });
  }

  getBenefitCodes(): Observable<CodeModel[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });    
    return this.baseHttpService.get<CodeModel[]>(administrationConst.benefitCodes, { headers: headers });
  }


}